import Aplicaciones from './Aplicaciones'
export default Aplicaciones